export default "__VITE_ASSET__DFQ7pdWK__"